module.exports = __webpack_public_path__ + "media/svg-new/bone-1-5db9711b.svg";